export function allOf(conditions: boolean[], value = true): boolean {
  return conditions.every(a => a === value);
}

export function anyOf(
  conditions: (boolean | undefined)[],
  value = true,
): boolean {
  return conditions.some(a => Boolean(a) === value);
}

export function not(value?: boolean): boolean {
  return !value;
}
